import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Music24LicenseStateType } from 'fym-common/src/license/music24Types';
import { licenseSliceName } from './constants';
import { LicenseState } from './state';

const licenseSlice = createSlice({
  name: licenseSliceName,
  initialState: LicenseState,
  reducers: {
    resetLicenseState: () => LicenseState,
    setLicenseInfoResult: (state, action: PayloadAction<Music24LicenseStateType>) => {
      return action.payload;
    },
  },
});

const { actions, reducer } = licenseSlice;
export const { setLicenseInfoResult, resetLicenseState } = actions;
export { reducer as licenseReducer };
